import {parseDate} from "./utils";

const submitJson = (url, data, method) =>
    fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })


export const post = (url, data) => submitJson(url, data, 'POST')

export const put = (url, data) => submitJson(url, data, 'PUT')

export const del = (url, data) => submitJson(url, data, 'DELETE')


export const resetPassword = (password, guid) =>
    put(`/resetPassword`, {password, guid})

export const login = (email, password) =>
    post(`/api/login`, {email, password})

export const postNewDossier = dossier =>
    post(`/api/dossiers`, dossier)

export const updateDossier = dossier =>
    put(`/api/dossiers`, dossier)

export const getMyDossiers = () =>
    fetch(`/api/my_dossiers`)

export const getMe = () =>
    fetch(`/api/me`)

export const getDossier = id =>
    fetch(`/api/dossiers/${id}`)

export const getRounds = dossier_id =>
    fetch(`/api/dossiers/${dossier_id}/rounds`)

export const newRound = (dossier_id, visit_date) =>
    post(`/api/dossiers/${dossier_id}/rounds`, {visit_date})

export const newObservation = (roundId, observation_type_id, fields) => {
    return post(`/api/observations`, {
        round_id: roundId,
        observation_type_id: observation_type_id,
        fields
    })
}

export const updateObservation = (observation_round_id, fields) => {
    return put(`/api/observations`, {
        observation_round_id,
        fields
    })
}

export const deleteObservation = (observation_round_id) =>
    del(`/api/observations/${observation_round_id}`)


export const saveNotes = (text, observation_type_id, round_id) =>
    put(`/api/notes`, {text, observation_type_id, round_id})


export const getUsers = () =>
    fetch(`/api/users`)


export const doPersonify = (user_id) =>
    fetch(`/api/personify/${user_id}`, {})


export const deleteDossier = (dossier_id) =>
    del(`/api/dossiers/${dossier_id}`)